module.exports = __webpack_public_path__ + "static/media/halo_top_nyc_22.ef4f9954.png";